import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient, emptyPaginationResponse } from '@utils/clientApi'

export const useCampaignResultsFetch = () => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()

  const query = usePaginatedQuery({
    queryKey: queryKeys.campaign.list(locale),
    queryFn: (pageQuery) => {
      if (account?.id) {
        return apiClient.getCampaigns({
          ...pageQuery,
          caller: 'ca',
          languageId: locale,
        })
      }
      return Promise.resolve(emptyPaginationResponse)
    },
    enabled: !!account?.id,
  })

  return { query, forceRefresh: query.forceRefresh }
}
